
// @ts-nocheck

import { useState, useEffect } from 'react';
import { supabase, safeQuery } from '@/integrations/supabase/client';
import { useAuth } from '@/providers/AuthProvider';
import { toast } from '@/components/ui/use-toast';

interface PaymentMethod {
  id: string;
  user_id: string;
  card_type: string;
  last_four: string;
  expiry_month: number;
  expiry_year: number;
  cardholder_name: string;
  is_primary: boolean;
  is_verified: boolean;
  created_at: string;
}

export const usePaymentMethods = () => {
  const { user } = useAuth();
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPaymentMethods = async () => {
    try {
      setLoading(true);
      setError(null);
      
      if (!user) {
        setPaymentMethods([]);
        setLoading(false);
        return;
      }

      const result = await safeQuery<PaymentMethod[]>(
        supabase
          .from('user_payment_methods')
          .select('*')
          .eq('user_id', user.id)
          .order('created_at', { ascending: false })
      );

      if (result.error) {
        console.error('Error fetching payment methods:', result.error);
        setError(result.error);
        return;
      }

      setPaymentMethods(result.data || []);
    } catch (err: any) {
      console.error('Unexpected error fetching payment methods:', err);
      setError(err.message || 'Failed to fetch payment methods');
      toast({
        title: "Error",
        description: "Failed to load payment methods. Please try again.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentMethods();
  }, [user]);

  return {
    paymentMethods,
    loading,
    error,
    refetch: fetchPaymentMethods
  };
};
